import { ContextStore } from 'bernie-core';
import { Logger } from 'bernie-logger';

import { bffFetch, Headers } from './bff-fetch';

export class BentoSource {
  private readonly host: string;
  private readonly logger: Logger;
  private readonly forwardedHeaders: Headers;

  constructor(host = '', logger, forwardedHeaders: Headers = {}) {
    this.host = host;
    this.logger = logger;
    this.forwardedHeaders = forwardedHeaders;
  }

  public fetch(context: ContextStore) {
    return bffFetch(this.host, `layout`, context, null, this.logger, this.forwardedHeaders);
  }
}
